import React, { useState } from 'react';
import Menu from '../menu';
import PlatformCheck from '../PlatformCheck';


export default function Principal() {

  const [platform, setPlatform] = useState('Desconhecida');
  const [setSelectedCnpj] = useState('');

  return (
    <div>
      <PlatformCheck setPlatform={setPlatform} />
      <div className='container-fluid'>
        <Menu setSelectedCnpj={setSelectedCnpj} />                
        <div className='text'>Plataforma atual: {platform}</div>
      </div>
    </div>
  );
}
